import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
 imageEndpoint = environment.apiUrl + `/Businesses/logo?=${location.hostname.substring(0, location.hostname.indexOf('.'))}`;
}
